if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Intercept Dynamic Checkout ("Buy it now") when Gift Wrap is checked
        this.addEventListener('click', this.onDynamicCheckoutClick.bind(this), true);
      }

      onDynamicCheckoutClick(evt) {
        const paymentButton = evt.target.closest('.shopify-payment-button') || evt.target.closest('[data-testid="Checkout-button"]');
        if (!paymentButton) return;

        const giftWrapCheckbox = this.form.querySelector('.gift-wrap-checkbox');
        if (!giftWrapCheckbox || !giftWrapCheckbox.checked) {
          // If gift wrap is not checked, do not block native accelerated checkout!
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const btn = paymentButton.querySelector('button') || paymentButton;
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');

        // Ensure spinner exists inside the Buy It Now button
        let spinner = btn.querySelector('.loading__spinner');
        if (!spinner) {
          spinner = document.createElement('div');
          spinner.className = 'loading__spinner';
          spinner.innerHTML = `
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 2.2rem; height: 2.2rem;">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          `;
          btn.appendChild(spinner);
        }
        spinner.classList.remove('hidden');

        // Hide button text span if present
        const innerText = btn.querySelector('[role="button"]') || btn;
        if (innerText && innerText !== btn) innerText.style.color = 'transparent';

        const formData = new FormData(this.form);
        const variantId = parseInt(this.variantIdInput?.value || formData.get('id'));
        if (!variantId || isNaN(variantId)) {
          console.error('Invalid variant ID');
          this.resetDynamicCheckoutButton(btn, spinner, innerText);
          return;
        }

        const quantity = parseInt(formData.get('quantity') || 1);
        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const propKey = key.slice(11, -1);
            properties[propKey] = value;
          }
        }
        properties['Gift Wrap'] = 'Yes';

        const items = [
          {
            id: variantId,
            quantity: quantity,
            properties: properties
          }
        ];

        const rawGvId = giftWrapCheckbox.dataset.giftWrapVariantId || (window.themeSettings ? window.themeSettings.giftWrapVariantId : null);
        const giftVariantId = parseInt(rawGvId);
        if (giftVariantId && !isNaN(giftVariantId) && giftVariantId > 0) {
          items.push({
            id: giftVariantId,
            quantity: quantity
          });
        }

        const cartAddUrl = routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`;

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status && response.status !== 200) {
              this.handleErrorMessage(response.description || response.message);
              this.resetDynamicCheckoutButton(btn, spinner, innerText);
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch((e) => {
            console.error('Error during checkout redirection:', e);
            window.location.href = '/checkout';
          });
      }

      resetDynamicCheckoutButton(btn, spinner, innerText) {
        if (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('disabled');
        }
        if (spinner) spinner.classList.add('hidden');
        if (innerText && innerText !== btn) innerText.style.color = '';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.submitButton.querySelector('.loading__spinner') || this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Also handle sticky ATC submit button loading if present
        const stickySubmit = document.querySelector('.sticky-atc-bar__submit');
        if (stickySubmit) {
          stickySubmit.classList.add('loading');
          const stickySpinner = stickySubmit.querySelector('.loading__spinner');
          if (stickySpinner) stickySpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const giftWrapCheckbox = this.form.querySelector('.gift-wrap-checkbox');
        const rawGvId = giftWrapCheckbox?.dataset.giftWrapVariantId || (window.themeSettings ? window.themeSettings.giftWrapVariantId : null);
        const giftVariantId = parseInt(rawGvId);

        if (giftWrapCheckbox && giftWrapCheckbox.checked && giftVariantId && !isNaN(giftVariantId) && giftVariantId > 0) {
          const items = [];
          const properties = {};
          for (const [key, value] of formData.entries()) {
            if (key.startsWith('properties[')) {
              const propKey = key.slice(11, -1);
              properties[propKey] = value;
            }
          }
          items.push({
            id: parseInt(this.variantIdInput?.value || formData.get('id')),
            quantity: parseInt(formData.get('quantity') || 1),
            properties: properties
          });
          items.push({
            id: giftVariantId,
            quantity: parseInt(formData.get('quantity') || 1)
          });
          const jsonBody = {
            items: items
          };
          if (this.cart) {
            jsonBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
            jsonBody.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = JSON.stringify(jsonBody);
        } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measure('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            if (stickySubmit) {
              stickySubmit.classList.remove('loading');
              const stickySpinner = stickySubmit.querySelector('.loading__spinner');
              if (stickySpinner) stickySpinner.classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
